// Compact, collision-resistant client id — hand-rolled (the player is
// zero-runtime-deps, so no nanoid). 21 symbols from a 64-char URL-safe alphabet
// backed by crypto.getRandomValues ≈ 126 bits of entropy: more than enough to
// dedupe playback events and tag snapshot requests without a central authority.

const ALPHABET = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

export function makeId(size = 21): string {
  const bytes = new Uint8Array(size);
  crypto.getRandomValues(bytes);
  let id = '';
  for (let i = 0; i < size; i++) id += ALPHABET[bytes[i]! & 63];
  return id;
}
